import React, { useEffect, useState } from "react";
import Default from "../../components/defaults/Default";
import { NavLink } from "react-router-dom";
import PostRequest from "../../servies/PostRequest";
import Moment from "react-moment";

const Forms = () => {
  // const [formData, setFormData] = useState([]);

  const [formData, setFormData] = useState({});

  const loadFormData = async () => {
    try {
      const response = await PostRequest("/forms");

      console.log("form", response);

      setFormData(response);
    } catch (error) {}
  };

  useEffect(() => {
    loadFormData();
  }, []);

  return (
    <Default>
      <div className="page-body">
        <div className="container-fluid">
          <div className="page-title">
            <div className="row">
              <div className="col-6">
                <h3>Manage Typeform Forms</h3>
              </div>
              <div className="col-6">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a className="home-item" href="#">
                      <i data-feather="home" />
                    </a>
                  </li>
                  <li className="breadcrumb-item">Home</li>
                  <li className="breadcrumb-item active">Forms</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        {/* Container-fluid starts*/}
        <div className="container-fluid ecommerce-page">
          <div className="row">
            <div className="col-xl-12 col-lg-12">
              <div className="card employee-status">
                <div className="card-header pb-0">
                  <h3>Forms List</h3>
                  <div className="card-header-right">
                    <ul className="list-unstyled card-option">
                      <li>
                        <div>
                          <i className="icon-settings" />
                        </div>
                      </li>
                      <li>
                        <i className="view-html fa fa-code" />
                      </li>
                      <li>
                        <i className="icofont icofont-maximize full-card" />
                      </li>
                      <li>
                        <i className="icofont icofont-minus minimize-card" />
                      </li>
                      <li>
                        <i className="icofont icofont-refresh reload-card" />
                      </li>
                      <li>
                        <i className="icofont icofont-error close-card"> </i>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-bordernone">
                      <thead>
                        <tr>
                          <th>Typeform</th>
                          <th className="text-center">Questions</th>
                          <th className="text-center">Responses</th>
                          <th>Completion</th>
                          <th>Updated</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {formData.items?.map((formItem) => (
                          <tr>
                            <td>
                              <div className="d-flex">
                                <div className="form-icon" />
                                <div className="flex-grow-1">
                                  <NavLink to={`/forms/${formItem.id}`}>
                                    <h5>{formItem.title}</h5>
                                  </NavLink>
                                </div>
                              </div>
                            </td>
                            <td className="text-center">10</td>
                            <td className="text-center">100</td>
                            <td>
                              <div className="progress-showcase">
                                <div className="progress" style={{ height: 8 }}>
                                  <div
                                    className="progress-bar bg-primary"
                                    role="progressbar"
                                    style={{ width: "30%" }}
                                    aria-valuenow={30}
                                    aria-valuemin={0}
                                    aria-valuemax={100}
                                  />
                                </div>
                              </div>
                            </td>
                            <td>
                              <Moment
                                format="DD-MM-YYYY hh:mm A"
                                date={formItem.last_updated_at}
                              />
                            </td>
                            <td>
                              <i className="fa fa-ellipsis-h more-action" />
                            </td>
                          </tr>
                        ))}
                        {/* Row 2 */}
                        {/* <tr>
                          <td>
                            <div className="d-flex">
                              <div className="form-icon" />
                              <div className="flex-grow-1">
                                <a href="user-profile.html">
                                  <h5>Another task Part 2</h5>
                                </a>
                              </div>
                            </div>
                          </td>
                          <td className="text-center">5</td>
                          <td className="text-center">50</td>
                          <td>
                            <div className="progress-showcase">
                              <div className="progress" style={{ height: 8 }}>
                                <div
                                  className="progress-bar bg-primary"
                                  role="progressbar"
                                  style={{ width: "50%" }}
                                  aria-valuenow={50}
                                  aria-valuemin={0}
                                  aria-valuemax={100}
                                />
                              </div>
                            </div>
                          </td>
                          <td>24 Nov 2023</td>
                          <td>
                            <i className="fa fa-ellipsis-h more-action" />
                          </td>
                        </tr> */}
                        {/* Row 3 */}
                        {/* <tr>
                          <td>
                            <div className="d-flex">
                              <div className="form-icon" />
                              <div className="flex-grow-1">
                                <a href="user-profile.html">
                                  <h5>Task Three Part 3</h5>
                                </a>
                              </div>
                            </div>
                          </td>
                          <td className="text-center">8</td>
                          <td className="text-center">80</td>
                          <td>
                            <div className="progress-showcase">
                              <div className="progress" style={{ height: 8 }}>
                                <div
                                  className="progress-bar bg-primary"
                                  role="progressbar"
                                  style={{ width: "80%" }}
                                  aria-valuenow={80}
                                  aria-valuemin={0}
                                  aria-valuemax={100}
                                />
                              </div>
                            </div>
                          </td>
                          <td>25 Nov 2023</td>
                          <td>
                            <i className="fa fa-ellipsis-h more-action" />
                          </td>
                        </tr> */}
                        {/* Row 4 */}
                        {/* <tr>
                          <td>
                            <div className="d-flex">
                              <div className="form-icon" />
                              <div className="flex-grow-1">
                                <a href="user-profile.html">
                                  <h5>Task Four Part 4</h5>
                                </a>
                              </div>
                            </div>
                          </td>
                          <td className="text-center">3</td>
                          <td className="text-center">30</td>
                          <td>
                            <div className="progress-showcase">
                              <div className="progress" style={{ height: 8 }}>
                                <div
                                  className="progress-bar bg-primary"
                                  role="progressbar"
                                  style={{ width: "20%" }}
                                  aria-valuenow={20}
                                  aria-valuemin={0}
                                  aria-valuemax={100}
                                />
                              </div>
                            </div>
                          </td>
                          <td>26 Nov 2023</td>
                          <td>
                            <i className="fa fa-ellipsis-h more-action" />
                          </td>
                        </tr> */}
                        {/* Row 5 */}
                        {/* <tr>
                          <td>
                            <div className="d-flex">
                              <div className="form-icon" />
                              <div className="flex-grow-1">
                                <a href="user-profile.html">
                                  <h5>Task Five Part 5</h5>
                                </a>
                              </div>
                            </div>
                          </td>
                          <td className="text-center">7</td>
                          <td className="text-center">70</td>
                          <td>
                            <div className="progress-showcase">
                              <div className="progress" style={{ height: 8 }}>
                                <div
                                  className="progress-bar bg-primary"
                                  role="progressbar"
                                  style={{ width: "70%" }}
                                  aria-valuenow={70}
                                  aria-valuemin={0}
                                  aria-valuemax={100}
                                />
                              </div>
                            </div>
                          </td>
                          <td>27 Nov 2023</td>
                          <td>
                            <i className="fa fa-ellipsis-h more-action" />
                          </td>
                        </tr> */}
                        {/* Row 6 */}
                        {/* <tr>
                          <td>
                            <div className="d-flex">
                              <div className="form-icon" />
                              <div className="flex-grow-1">
                                <a href="user-profile.html">
                                  <h5>Task Six Part 6</h5>
                                </a>
                              </div>
                            </div>
                          </td>
                          <td className="text-center">9</td>
                          <td className="text-center">90</td>
                          <td>
                            <div className="progress-showcase">
                              <div className="progress" style={{ height: 8 }}>
                                <div
                                  className="progress-bar bg-primary"
                                  role="progressbar"
                                  style={{ width: "60%" }}
                                  aria-valuenow={60}
                                  aria-valuemin={0}
                                  aria-valuemax={100}
                                />
                              </div>
                            </div>
                          </td>
                          <td>28 Nov 2023</td>
                          <td>
                            <i className="fa fa-ellipsis-h more-action" />
                          </td>
                        </tr> */}
                        {/* Row 7 */}
                        {/* <tr>
                          <td>
                            <div className="d-flex">
                              <div className="form-icon" />
                              <div className="flex-grow-1">
                                <a href="user-profile.html">
                                  <h5>Task Seven Part 7</h5>
                                </a>
                              </div>
                            </div>
                          </td>
                          <td className="text-center">2</td>
                          <td className="text-center">20</td>
                          <td>
                            <div className="progress-showcase">
                              <div className="progress" style={{ height: 8 }}>
                                <div
                                  className="progress-bar bg-primary"
                                  role="progressbar"
                                  style={{ width: "10%" }}
                                  aria-valuenow={10}
                                  aria-valuemin={0}
                                  aria-valuemax={100}
                                />
                              </div>
                            </div>
                          </td>
                          <td>29 Nov 2023</td>
                          <td>
                            <i className="fa fa-ellipsis-h more-action" />
                          </td>
                        </tr> */}
                        {/* Row 8 */}
                        {/* <tr>
                          <td>
                            <div className="d-flex">
                              <div className="form-icon" />
                              <div className="flex-grow-1">
                                <a href="user-profile.html">
                                  <h5>Task Eight Part 8</h5>
                                </a>
                              </div>
                            </div>
                          </td>
                          <td className="text-center">4</td>
                          <td className="text-center">40</td>
                          <td>
                            <div className="progress-showcase">
                              <div className="progress" style={{ height: 8 }}>
                                <div
                                  className="progress-bar bg-primary"
                                  role="progressbar"
                                  style={{ width: "40%" }}
                                  aria-valuenow={40}
                                  aria-valuemin={0}
                                  aria-valuemax={100}
                                />
                              </div>
                            </div>
                          </td>
                          <td>30 Nov 2023</td>
                          <td>
                            <i className="fa fa-ellipsis-h more-action" />
                          </td>
                        </tr> */}
                        {/* Row 9 */}
                        {/* <tr>
                          <td>
                            <div className="d-flex">
                              <div className="form-icon" />
                              <div className="flex-grow-1">
                                <a href="user-profile.html">
                                  <h5>Task Nine Part 9</h5>
                                </a>
                              </div>
                            </div>
                          </td>
                          <td className="text-center">6</td>
                          <td className="text-center">60</td>
                          <td>
                            <div className="progress-showcase">
                              <div className="progress" style={{ height: 8 }}>
                                <div
                                  className="progress-bar bg-primary"
                                  role="progressbar"
                                  style={{ width: "90%" }}
                                  aria-valuenow={90}
                                  aria-valuemin={0}
                                  aria-valuemax={100}
                                />
                              </div>
                            </div>
                          </td>
                          <td>1 Dec 2023</td>
                          <td>
                            <i className="fa fa-ellipsis-h more-action" />
                          </td>
                        </tr> */}
                        {/* Row 10 */}
                        {/* <tr>
                          <td>
                            <div className="d-flex">
                              <div className="form-icon" />
                              <div className="flex-grow-1">
                                <a href="user-profile.html">
                                  <h5>Last Task Part 10</h5>
                                </a>
                              </div>
                            </div>
                          </td>
                          <td className="text-center">1</td>
                          <td className="text-center">10</td>
                          <td>
                            <div className="progress-showcase">
                              <div className="progress" style={{ height: 8 }}>
                                <div
                                  className="progress-bar bg-primary"
                                  role="progressbar"
                                  style={{ width: "5%" }}
                                  aria-valuenow={5}
                                  aria-valuemin={0}
                                  aria-valuemax={100}
                                />
                              </div>
                            </div>
                          </td>
                          <td>2 Dec 2023</td>
                          <td>
                            <i className="fa fa-ellipsis-h more-action" />
                          </td>
                        </tr> */}
                      </tbody>
                    </table>
                  </div>
                  <div className="code-box-copy">
                    <button
                      className="code-box-copy__btn btn-clipboard"
                      data-clipboard-target="#employee-status"
                      title
                      data-bs-original-title="Copy"
                      aria-label="Copy"
                    >
                      <i className="icofont icofont-copy-alt" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Container-fluid Ends*/}
      </div>
    </Default>
  );
};

export default Forms;
